import fetch from 'unfetch';
import autosize from 'autosize';
import { slideIn, slideOut } from '../animations';
import recaptcha from '../../utils/recaptcha';
import { setThanks } from './thanks';

let selectedForm = -1;

export function getForm() {
  return selectedForm;
}

export function setForm(index) {
  selectedForm = index;
}

export default function formsSteps(presentation) {
  const { elements, presentations } = presentation;

  const {
    formView,
    formForm,
    formRecaptcha,
    formQuestionAnswer,
    formFieldFirstName,
    formButtonText,
  } = elements;

  if (
    !(
      formForm.length === formRecaptcha.length &&
      formForm.length === formView.length &&
      formForm.length === formFieldFirstName.length &&
      formForm.length === formButtonText.length
    )
  ) {
    return;
  }

  if (!formView[selectedForm]) {
    return;
  }

  Promise.resolve().then(() => {
    if (presentation.currentId !== 'form') {
      // We navigated out of form, lets get rid of it
      selectedForm = -1;
      presentations.fadePromise.then(() => {
        presentations.reset();
      });
    }
  });

  const view = formView[selectedForm];
  const form = formForm[selectedForm];
  const recaptchaContainer = formRecaptcha[selectedForm];
  const formButton = formButtonText[selectedForm];
  const formQuestion = formQuestionAnswer[selectedForm];
  let recaptchaId = -1;

  const recaptchaCallback = () => {
    const serialized = Array.from(form.elements)
      .filter(el => el.name)
      .map(
        el => `${encodeURIComponent(el.name)}=${encodeURIComponent(el.value)}`,
      )
      .join('&');

    formButton.textContent = 'Sending...';
    formButton.disabled = true;

    let send = () =>
      fetch(form.getAttribute('action'), {
        method: form.getAttribute('method'),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: serialized,
      });

    if (process.env.NODE_ENV !== 'production') {
      send = () => fetch(window.location.href);
    }

    send()
      .then(res => Promise[res.ok ? 'resolve' : 'reject'](res))
      .then(() => {
        setThanks({ firstName: formFieldFirstName[selectedForm].value });
        presentations.fade('thanks');
      })
      .catch(() => {
        formButton.textContent = 'Error :(';
      })
      .finally(() => {
        formButton.disabled = false;
      });
  };

  form.addEventListener('submit', e => {
    e.preventDefault();
    recaptcha.then(grecaptcha => {
      if (process.env.NODE_ENV !== 'production') {
        recaptchaCallback();
      } else {
        grecaptcha.execute(recaptchaId);
      }
    });
  });

  recaptcha.then(grecaptcha => {
    if (process.env.NODE_ENV !== 'production') {
      return;
    }

    recaptchaId = grecaptcha.render(recaptchaContainer, {
      sitekey: process.env.SITE_RECAPTCHA_KEY,
      size: 'invisible',
      badge: 'bottomleft',
      callback: recaptchaCallback,
    });
  });

  const inputs = Array.from(form.querySelectorAll('input'));

  inputs.forEach(input => {
    input.addEventListener('invalid', () => {
      input.parentElement.classList.add('is-invalid');
    });

    input.addEventListener('input', () => {
      if (input.validity.valid) {
        input.parentElement.classList.remove('is-invalid');
      }
    });
  });

  // Resize answers to match written text
  autosize(formQuestion);

  presentation.addStep({
    id: `form`,
    default: {
      enter({ timeline, label }) {
        slideIn(view)({ timeline, label });
        // Reset when left the form
        timeline.call(
          () => {
            if (
              // eslint-disable-next-line no-underscore-dangle
              !timeline._forcingPlayhead &&
              timeline.reversed() &&
              selectedForm !== -1
            ) {
              selectedForm = -1;
              presentations.reset();
            }
          },
          null,
          null,
          label,
        );
      },
      leave: slideOut(view),
    },
    // large: {
    //   enter: enter(false),
    //   leave(props) {
    //     hide([
    //       becomeHeadingMoving[initialIndex],
    //       becomeBelowHeading[initialIndex],
    //     ])(props);
    //     slideOut(logoLetters[initialIndex])(props);
    //   },
    // },
  });
}



// WEBPACK FOOTER //
// ./src/scripts/modules/steps/forms.js